import { Platform } from "react-native";

import { AppVariant, getAppVariant } from "./expo";

import type { ApiVersion, Version } from "@/schemas/app/version";

export function getLatestAppVersion(results: ApiVersion): Version {
  const appVariant = getAppVariant();

  switch (appVariant) {
    case AppVariant.PRODUCTION:
      switch (Platform.OS) {
        case "ios":
          return results.ios.public;
        case "android":
          return results.android.public;
        default:
          throw new Error(`Unsupported platform: ${Platform.OS}`);
      }
    case AppVariant.PREVIEW:
      switch (Platform.OS) {
        case "ios":
          return results.ios.preview;
        case "android":
          return results.android.preview;
        default:
          throw new Error(`Unsupported platform: ${Platform.OS}`);
      }
    case AppVariant.DEVELOPMENT:
      switch (Platform.OS) {
        case "ios":
          return results.ios.development;
        case "android":
          return results.android.development;
        default:
          throw new Error(`Unsupported platform: ${Platform.OS}`);
      }
    case AppVariant.SIMULATOR:
      switch (Platform.OS) {
        case "ios":
          return results.ios.development;
        case "android":
          return results.android.development;
        default:
          throw new Error(`Unsupported platform: ${Platform.OS}`);
      }
    default:
      throw new Error(`Unsupported variant: ${appVariant}`);
  }
}

export function getAppVersionString(version: Version | null): string {
  if (!version) {
    return "Unknown";
  }
  return `${version.major}.${version.minor}.${version.patch}`;
}
